import { useAppContext } from '../../context/AppContext';
import { PriceTrans } from '../../utils/translations';
import { passCurrencySymbol } from '../../utils/currencyFormat';

/**
 * EUR is display-only (AllPay does not accept EUR): shows "≈ X €" with the amounts actually
 * charged in small grey text below. Without eur, falls back to "200₪ / 5000₽".
 * charges: [{ amount, currency }] — entries without a positive amount are skipped.
 */
export default function ApproxPrice({ eur, charges = [], suffix = '', className = '', subClassName = 'text-ink-light' }) {
  const { language } = useAppContext();
  const t = PriceTrans[language] || PriceTrans.english;
  const charged = charges
    .filter((c) => c.amount > 0)
    .map((c) => `${c.amount}${passCurrencySymbol(c.currency)}`);
  const unit = suffix ? ` ${suffix}` : '';

  if (!eur) {
    return <span className={className}>{charged.join(' / ')}{unit}</span>;
  }

  return (
    <>
      <span className={className}>≈ {eur} €{unit}</span>
      {charged.length > 0 && (
        <span className={`block text-xs font-sans font-light mt-1 ${subClassName}`}>
          {t.paidAs} {charged.join(` ${t.or} `)}
        </span>
      )}
    </>
  );
}
